// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '../../../Utility/Grid';
import { Text } from '../../../BuildingBlocks/Text';
import { StyledIcon, NoDataContainer } from './NoData.styles';

function NoData(props) {
  const { actionLabel, actionHref, actionOnClick, icon, message, title } = props;
  return (
    <NoDataContainer>
      <Grid.Row justify="center" align="center">
        <Grid.Col xs={12} md={6}>
          <StyledIcon selectedIcon={icon} />
          <Text.HeadingFifth align="center">{title}</Text.HeadingFifth>
          <Text.CopyBody align="center">{message}</Text.CopyBody>
          {actionLabel && (
            <Text.HeadingFifth align="center" color="quaternary">
              <a href={actionHref} onClick={actionOnClick}>
                {actionLabel}
              </a>
            </Text.HeadingFifth>
          )}
        </Grid.Col>
      </Grid.Row>
    </NoDataContainer>
  );
}

NoData.propTypes = {
  actionLabel: PropTypes.string,
  actionHref: PropTypes.string,
  actionOnClick: PropTypes.func,
  icon: PropTypes.string,
  message: PropTypes.string,
  title: PropTypes.string
};

NoData.defaultProps = {
  actionLabel: 'Create a New Item',
  actionHref: '#',
  actionOnClick: () => {},
  icon: 'projects',
  message:
    'Once you create items you’ll be able to see them all here, view their status, pertinent details, and click to view the further details or complete an item',
  title: 'You haven’t created any items yet'
};

export default NoData;
